export const PARTNER_SELECT_INTENTS = [
  "link-users",
  "projects",
  "campaigns",
  "whatsapp",
] as const;

export type TPartnerSelectIntent = (typeof PARTNER_SELECT_INTENTS)[number];

export function isPartnerSelectIntent(
  value: string | undefined
): value is TPartnerSelectIntent {
  return (
    value !== undefined &&
    (PARTNER_SELECT_INTENTS as readonly string[]).includes(value)
  );
}
